import classNames from "../../utility/classNames";

const getColorClasses = (color) => {
  switch (color) {
    case "red":
      return "bg-white text-signal-red-700 ring-1 ring-inset ring-signal-red-100 hover:bg-signal-red-50 focus-visible:outline-signal-red-500";
    case "green":
      return "bg-white text-accent-700 ring-1 ring-inset ring-signal-green-100 hover:bg-signal-green-50 focus-visible:outline-signal-green-500";
    case "blue":
      return "bg-ink-800 text-cream-50 hover:bg-ink-700 focus-visible:outline-ink-700";
    case "amber":
      return "bg-white text-signal-amber-600 ring-1 ring-inset ring-signal-amber-100 hover:bg-signal-amber-50 focus-visible:outline-signal-amber-500";
    case "gray":
    case "slate":
    case "neutral":
    default:
      return "bg-white text-ink-800 ring-1 ring-inset ring-ink-200 hover:bg-cream-100 focus-visible:outline-ink-500";
  }
};

const SecondaryButton = ({
  children,
  onClick,
  colour = "gray",
  className = "",
  disabled = false,
}) => {
  const colorClasses = getColorClasses(colour);

  const style = classNames(
    colorClasses,
    "inline-flex items-center justify-center rounded-pill px-4 py-2 text-center text-sm font-medium tracking-[-0.005em]",
    "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
    "transition-[background-color,transform] duration-150 ease-editorial",
    !disabled && "active:scale-[0.98]",
    disabled && "opacity-50 cursor-not-allowed",
    className
  );

  return (
    <button
      onClick={onClick}
      type="button"
      className={style}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
